import { makeStyles } from '@material-ui/core/styles';
import { redesignTheme } from '../../theme';

const { colors, fonts, fontSize, spacing, radius, breakpoints } = redesignTheme;

export const useCompassHeroStyles = makeStyles(() => ({
  heroCard: {
    backgroundColor: colors.white,
    borderRadius: radius.sm,
    padding: `${spacing.md}px ${spacing.sm}px`,
    display: 'flex',
    flexDirection: 'column',
    gap: spacing.lg,
    alignItems: 'center',
    [`@media (min-width: ${breakpoints.tablet}px)`]: {
      flexDirection: 'row',
      padding: `${spacing.md}px 40px`,
      gap: 50,
    },
  },
  heroVisual: {
    width: '100%',
    maxWidth: 480,
    flexShrink: 0,
    display: 'flex',
    justifyContent: 'center',
    overflow: 'visible',
    [`@media (min-width: ${breakpoints.tablet}px)`]: {
      width: '45%',
    },
    // Shared compass labels size by viewport; this visual is capped at 480px, so
    // desktop font sizes overflow into the decorative arcs (esp. PERSONNALITÉ).
    '& a': {
      fontSize: '11px !important',
      whiteSpace: 'nowrap',
      [`@media (max-width: ${breakpoints.mobile}px)`]: {
        fontSize: '8.5px !important',
      },
    },
    '& a[href="#preference-personality"]': {
      width: 'max-content',
      maxWidth: 'none',
      zIndex: 2,
    },
  },
  heroContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing.md,
    flex: 1,
  },
  heroHeading: {
    margin: 0,
    fontFamily: fonts.opensansBold,
    fontSize: fontSize.intro,
    color: colors.primaryDark,
    textTransform: 'uppercase',
    lineHeight: 'normal',
  },
  heroDescription: {
    margin: 0,
    fontFamily: fonts.opensans,
    fontSize: fontSize.intro,
    color: colors.primaryDark,
    lineHeight: 1.8,
    [`@media (max-width: ${breakpoints.mobile}px)`]: {
      fontSize: fontSize.base,
    },
  },
  switchRow: {
    display: 'flex',
    alignItems: 'center',
    gap: spacing.xs,
  },
  switchLabel: {
    fontFamily: fonts.gothicSemiBold,
    fontSize: fontSize.base,
    color: colors.primaryDark,
    textTransform: 'uppercase',
  },
}));
